import EmployeeJobType from 'src/models/employee-job-type/EmployeeJobType'
import Model, { encoders, ID, MODEL_LEVEL } from 'src/models/model'
import User from 'src/models/user/User'

export default class UserEmployeeJobType extends Model {
  static name = 'UserEmployeeJobType'

  static versioned = true
  static deletable = true

  static level = MODEL_LEVEL.SITE
  static employeeRequiredPermissionCategories = [Model.permissionCategories.Team]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      user: {
        type: User,
        default: null,
        output: true,
        reference: true
      },
      employeeJobType: {
        type: EmployeeJobType,
        default: null,
        reference: true
      },
      default: {
        type: Boolean,
        default: false
      },
      overrideHourlyRate: {
        type: Number,
        encode: encoders.cents,
        default: null
      }
    }
  }

  get name () {
    return this.employeeJobType.name
  }

  get hasHourlyRateOverride () {
    return !_.isNil(this.overrideHourlyRate)
  }

  get hourlyRate () {
    return this.hasHourlyRateOverride ? this.overrideHourlyRate : this.employeeJobType.hourlyRate
  }
}
